import {
  Stack,
  Text,
  TextInput,
  Tabs,
} from '@mantine/core';

interface NameTranslationsEditorProps {
  nameTranslations?: {
    pl?: string;
    en?: string;
    de?: string;
    fr?: string;
    es?: string;
    it?: string;
    [key: string]: string | undefined;
  };
  onChange: (nameTranslations: Record<string, string>) => void;
}

const LANGUAGES = [
  { code: 'pl', label: 'Polish (PL)' },
  { code: 'en', label: 'English (EN)' },
  { code: 'de', label: 'German (DE)' },
  { code: 'fr', label: 'French (FR)' },
  { code: 'es', label: 'Spanish (ES)' },
  { code: 'it', label: 'Italian (IT)' },
];

export function NameTranslationsEditor({ nameTranslations, onChange }: NameTranslationsEditorProps) {
  const updateName = (lang: string, value: string) => {
    const newTranslations = { ...nameTranslations };
    if (value.trim()) {
      newTranslations[lang] = value;
    } else {
      delete newTranslations[lang];
    }
    // Filter out undefined values and convert to Record<string, string>
    const filteredTranslations: Record<string, string> = {};
    Object.entries(newTranslations).forEach(([key, val]) => {
      if (val !== undefined) {
        filteredTranslations[key] = val;
      }
    });
    onChange(filteredTranslations);
  };

  return (
    <Stack gap="md">
      <div>
        <Text size="sm" fw={500} mb="xs">
          Name Translations
        </Text>
        <Text size="xs" c="dimmed">
          Add translated product names for different languages (optional)
        </Text>
      </div>

      <Tabs defaultValue="pl">
        <Tabs.List>
          {LANGUAGES.map((lang) => (
            <Tabs.Tab key={lang.code} value={lang.code}>
              {lang.label}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        {LANGUAGES.map((lang) => (
          <Tabs.Panel key={lang.code} value={lang.code} pt="md">
            <TextInput
              label={`Product Name (${lang.label})`}
              placeholder="Enter translated product name"
              value={nameTranslations?.[lang.code] || ''}
              onChange={(e) => updateName(lang.code, e.target.value)}
            />
          </Tabs.Panel>
        ))}
      </Tabs>
    </Stack>
  );
}

